export enum Entity {
  Encounter = 'ENCOUNTER',
  Patient = 'PATIENT',
  Order = 'ORDER',
}

export interface Result {
  id: string;
  entity: {
    name: string;
    type: Entity;
  };
  tags: string[];
  organization: string;
}
